package com.macrofocus.eflux.components

import com.macrofocus.eflux.components.link.GoogleMapLink
import com.macrofocus.eflux.components.link.GoogleStreetViewLink
import com.macrofocus.eflux.components.link.OpenInfraMapLink
import com.macrofocus.eflux.network.SubstationNetwork
import com.macrofocus.eflux.network.coordinate.Coordinate
import com.macrofocus.eflux.network.logical.logicalBranchIdOf
import com.macrofocus.eflux.ui.PaletteType
import com.macrofocus.eflux.ui.data.LineButton
import emotion.react.css
import i18next.useTranslation
import js.objects.unsafeJso
import mui.material.*
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.responsive
import mui.system.sx
import org.mkui.react.useProperty
import react.FC
import react.PropsWithChildren
import react.ReactNode
import react.dom.html.ReactHTML
import react.useRequired
import web.cssom.JustifyContent
import web.cssom.None
import web.cssom.px

external interface CoordinateInfoExtraProps : PropsWithChildren {
    var network: SubstationNetwork?
    var primary: Boolean
    var coordinate: Coordinate
    var coordinateTab: String
}

val CoordinateInfoExtra = FC<CoordinateInfoExtraProps> { props ->
    val context = useRequired(EFluxContext)

    val theme = useTheme<Theme>()
    val paletteType = if (theme.asDynamic().palette.mode == "dark") PaletteType.dark else PaletteType.light
    val (t, _) = useTranslation()

    val (coordinateTab, setCoordinateTab) = useProperty(context.coordinateTab)

    val dataLoader = context.dataLoader

    val coordinate = props.coordinate

    ReactHTML.div {
        css {
            height = 10.px
        }
    }

    Tabs {
        sx {
            maxWidth = 270.px
        }

        this.value = coordinateTab
        //                        variant = TabsVariant.scrollable
        asDynamic().size = Size.small
        onChange = { _, newValue -> setCoordinateTab(newValue.toString()) }

        Tab {
            sx {
                textTransform = None.none
            }
            label = ReactNode("Lines")
            this.value = "lines"
        }

        Tab {
            sx {
                textTransform = None.none
            }
            label = ReactNode("Weather")
            this.value = "weather"
        }

        Tab {
            sx {
                textTransform = None.none
            }
            label = ReactNode("Links")
            this.value = "links"
        }
    }

    when (coordinateTab) {
        "lines" -> {
            Stack {
                direction = responsive(StackDirection.column)
                asDynamic().justifyContent = JustifyContent.center
                sx {
                    marginTop = 10.px
                    marginBottom = 10.px
                }

                coordinate.logicalBranchIds?.split(",")?.forEach { it ->
                    val line = props.network?.lines?.get(logicalBranchIdOf(it))
                    if (line != null) {
                        Stack {
                            direction = responsive(StackDirection.row)
                            asDynamic().justifyContent = JustifyContent.center

                            LineButton {
                                this.dataLoader = dataLoader
                                this.primary = props.primary
                                this.probing = if(props.primary) dataLoader.controller.secondaryLogicalBranchProbing else dataLoader.controller.primaryLogicalBranchProbing
                                this.selection = if(props.primary) dataLoader.controller.secondaryLogicalBranchSelection else dataLoader.controller.primaryLogicalBranchSelection
                                this.logicalBranchId = line.logicalBranchId
                            }
                        }
                    }
                }
            }
        }

        "weather" -> {
            Stack {
                direction = responsive(StackDirection.column)

                Typography {
                    +"Temperature"
                }

                Slider {
                    sx {
                        maxWidth = 270.px
                    }
                    this.marks = arrayOf(
                        unsafeJso<dynamic> {
                            this.value = -50
                            this.label = "-50°C"
                        },
                        unsafeJso<dynamic> {
                            this.value = 0
                            this.label = "0°C"
                        },
                        //                                unsafeJso<dynamic> {
                        //                                        value = 20
                        //                                        label = "20°C"
                        //                                },
                        //                                unsafeJso<dynamic> {
                        //                                        value = 37
                        //                                        label = "37°C"
                        //                                },
                        unsafeJso<dynamic> {
                            this.value = 50
                            this.label = "50°C"
                        },
                    )

                    min = -50.0
                    max = 50.0
                    //                                    getAriaLabel="Temperature range"
                    defaultValue = coordinate.t_70m
                    valueLabelDisplay = "auto"
                }
            }

            Stack {
                direction = responsive(StackDirection.column)

                Typography {
                    +"Wind speed and gust"
                }

                Slider {
                    sx {
                        maxWidth = 270.px
                    }
//                                    this.marks = marks
                    min = 0.0
                    max = 250.0
                    this.marks = arrayOf(
                        unsafeJso<dynamic> {
                            this.value = 0
                            this.label = "0"
                        },
                        unsafeJso<dynamic> {
                            this.value = 250
                            this.label = "250km/h"
                        },
                    )
                    //                                    getAriaLabel="Temperature range"
                    defaultValue = arrayOf(coordinate.wind_speed_70m, coordinate.wind_gusts_70m_1h)
                    valueLabelDisplay = "auto"
                }
            }

            Stack {
                direction = responsive(StackDirection.column)

                Typography {
                    +"Precipitation"
                }

                Slider {
                    sx {
                        maxWidth = 270.px
                    }
                    this.marks = arrayOf(
                        unsafeJso<dynamic> {
                            this.value = 0
                            this.label = "0"
                        },
                        unsafeJso<dynamic> {
                            this.value = 250
                            this.label = "10mm/5min"
                        },
                    )
                    min = 0.0
                    max = 10.0
                    //                                    getAriaLabel="Temperature range"
                    defaultValue = coordinate.precip_5min
                    valueLabelDisplay = "auto"
                }
            }
        }

        "links" -> {
            //                        InstantZoomButton {
            //                            this.dataLoader = dataLoader
            //                            geometry = line.physicalGeometry
            //                            margin = 0.05
            //                        }
            //
            //                        if (expertMode) {
            //                            AnimatedZoomButton {
            //                                this.dataLoader = dataLoader
            //                                geometry = line.physicalGeometry
            //                                margin = 0.05
            //                            }
            //                        }

            GoogleMapLink {
                geometry = coordinate.physicalGeometry
                zoomLevel = dataLoader.maxZoomLevel.value - 1.0
            }

            GoogleStreetViewLink {
                geometry = coordinate.physicalGeometry
            }

            OpenInfraMapLink {
                geometry = coordinate.physicalGeometry
                zoomLevel = dataLoader.maxZoomLevel.value - 1.0
            }
        }
    }

}